import React from 'react';
import { StepWizardChildProps } from "react-step-wizard";
import { Button, Box, IconButton, Typography, Stack } from "@mui/material";
import { Close, NavigateNext } from "@mui/icons-material";
import Image from 'next/image'

type PartialStepWizardChildProps = Partial<StepWizardChildProps>

type HowItWorksCardsProps = PartialStepWizardChildProps & {
    handleClose: () => void;
    img: string;
    children: React.ReactElement | React.ReactElement[];
    currentStage?: string;
};

const HowItWorksCards = ({ nextStep, totalSteps, currentStep, children, handleClose, img, currentStage}: HowItWorksCardsProps) => {
    return (
        <Box sx={{backgroundColor: "#fff"}}>
            <IconButton sx={{position: "absolute", top: "8px", right: "8px" }} onClick={handleClose} color="neutralDark">
                <Close />
            </IconButton>

            <Image src={img} alt='discover image' width={382} height={224}/>
            
            <Box sx={{padding: "32px", paddingTop: "24px"}}>
                {children}
                {
                    currentStep === totalSteps ? 
                    <Button fullWidth onClick={handleClose}>Start browsing</Button> : 
                    <Stack justifyContent="space-between" alignItems="center" direction="row">
                        <Typography variant="text2" color="black.dark">
                            {currentStage}
                        </Typography>
                        <Button endIcon={<NavigateNext/>} onClick={() => nextStep()}>Next</Button>
                    </Stack>
                }
            </Box>
        </Box>
    )
}

export default HowItWorksCards;
